import React from 'react';
import { BookOpen } from 'lucide-react';

const ResearchBox = ({ title = 'Research', source, children }) => {
  return (
    <div className="relative my-8 bg-gradient-to-br from-courtyard-aegean/10 to-courtyard-aegean/5 border border-courtyard-aegean/25 rounded-2xl p-6 shadow-sm overflow-hidden">
      <div className="absolute top-0 right-0 w-24 h-24 bg-courtyard-aegean/5 rounded-bl-full" />
      <div className="relative">
        <div className="flex items-center gap-2.5 mb-3">
          <div className="w-8 h-8 rounded-lg bg-courtyard-aegean/20 flex items-center justify-center">
            <BookOpen className="w-4.5 h-4.5 text-courtyard-aegean-dark" aria-hidden="true" />
          </div>
          <div>
            <h4 className="font-display font-bold text-courtyard-stone text-base">{title}</h4>
            {source && (
              <p className="text-xs text-courtyard-aegean-dark font-medium">{source}</p>
            )}
          </div>
        </div>
        <div className="text-[15px] text-courtyard-stone/80 leading-relaxed space-y-2.5 pl-[42px]">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ResearchBox;
